import React from 'react';

import mixpanel from '~/components/CmsMain/mixpanel';
import { Text } from '~/components/core';
import Link from '~/components/core/Atomic/Link/Link';
import MenuItem from '~/components/core/Atomic/MenuItem';
import { useCms } from '~/components/hooks/useCms';
import { QuestionCircleIcon } from '~/components/icons';
import FileIcon from '~/components/icons/FileIcon';
import Popover from '~/components/ui/atoms/Popover';
import { MIXPANEL_EVENTS } from '~/pocs/mixpanel';
import LEGACY_ORG_FEATURES from '~/server_shared/generated-types/LEGACY_ORG_FEATURES';
import { isLegacyOrgFeatureEnabled } from '~/Utils';

interface Props {
  onClose: () => void;
  anchorEl: Element | null;
  /** The popover's id, which the Support button's aria-controls names. */
  id?: string;
}

const SupportMenu: React.FC<Props> = ({ onClose, anchorEl, id }) => {
  const { userOrganization } = useCms();

  const linkClassName = 'flex items-center p-16 text-slate-800 gap-4';
  return (
    <Popover
      open={Boolean(anchorEl)}
      anchorEl={anchorEl}
      onClose={onClose}
      id={id}
      aria-label="Support"
      // Over the Support button, end edges aligned, as the MUI popover placed it.
      align="end"
      sideOffset={({ anchor }) => -anchor.height}
    >
      <div className="flex flex-col gap-12 rounded-md p-4">
        {!isLegacyOrgFeatureEnabled(userOrganization, LEGACY_ORG_FEATURES.HOSPITALITY_HIDE_DOCUMENTATION_LINK) && (
          <MenuItem className={linkClassName}>
            <FileIcon size={20} iconColor="currentColor" />
            <Link
              href="https://docs.fivesigmalabs.com/90QdzjlkkzeSKsiP9PE0/"
              underline="none"
              color="inherit"
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => {
                mixpanel.track(MIXPANEL_EVENTS.DOCUMENTATION_LINK_CLICKED);
              }}
            >
              <Text
                variant={Text.VARIANTS.SM}
                weight={Text.WEIGHTS.REGULAR}
                colorVariant={Text.COLOR_VARIANTS.SECONDARY}
              >
                Documentation
              </Text>
            </Link>
          </MenuItem>
        )}
        <MenuItem className={linkClassName}>
          <QuestionCircleIcon size={20} iconColor="currentColor" />
          <Link
            href="https://fivesigmahelp.zendesk.com/hc/en-us/requests/new"
            underline="none"
            color="inherit"
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => {
              mixpanel.track(MIXPANEL_EVENTS.SUPPORT_LINK_CLICKED);
            }}
          >
            <Text variant={Text.VARIANTS.SM} weight={Text.WEIGHTS.REGULAR} colorVariant={Text.COLOR_VARIANTS.SECONDARY}>
              Support
            </Text>
          </Link>
        </MenuItem>
      </div>
    </Popover>
  );
};

export default SupportMenu;
